import { msg } from "@lingui/core/macro";
import type { Country } from "./types";

/**
 * A common subset. For a complete, always-correct list, replace this array
 * with metadata derived from `libphonenumber-js` (or any country-data JSON).
 * The component only needs { name, iso2, dialCode }.
 */
export const COUNTRIES: Country[] = [
  // { name: msg({ id: "Country_name_au", message: "Australia" }), iso2: "AU", dialCode: "+61" },
  // { name: msg({ id: "Country_name_at", message: "Austria" }), iso2: "AT", dialCode: "+43" },
  // { name: msg({ id: "Country_name_be", message: "Belgium" }), iso2: "BE", dialCode: "+32" },
  // { name: msg({ id: "Country_name_br", message: "Brazil" }), iso2: "BR", dialCode: "+55" },
  // { name: msg({ id: "Country_name_ca", message: "Canada" }), iso2: "CA", dialCode: "+1" },
  {
    name: msg({ id: "Country_name_cn", message: "China" }),
    iso2: "CN",
    dialCode: "+86",
  },
  // { name: msg({ id: "Country_name_cz", message: "Czechia" }), iso2: "CZ", dialCode: "+420" },
  // { name: msg({ id: "Country_name_dk", message: "Denmark" }), iso2: "DK", dialCode: "+45" },
  // { name: msg({ id: "Country_name_fi", message: "Finland" }), iso2: "FI", dialCode: "+358" },
  // { name: msg({ id: "Country_name_fr", message: "France" }), iso2: "FR", dialCode: "+33" },
  // { name: msg({ id: "Country_name_de", message: "Germany" }), iso2: "DE", dialCode: "+49" },
  // { name: msg({ id: "Country_name_gr", message: "Greece" }), iso2: "GR", dialCode: "+30" },
  // { name: msg({ id: "Country_name_hk", message: "Hong Kong" }), iso2: "HK", dialCode: "+852" },
  // { name: msg({ id: "Country_name_hu", message: "Hungary" }), iso2: "HU", dialCode: "+36" },
  // { name: msg({ id: "Country_name_in", message: "India" }), iso2: "IN", dialCode: "+91" },
  // { name: msg({ id: "Country_name_id", message: "Indonesia" }), iso2: "ID", dialCode: "+62" },
  // { name: msg({ id: "Country_name_ie", message: "Ireland" }), iso2: "IE", dialCode: "+353" },
  // { name: msg({ id: "Country_name_it", message: "Italy" }), iso2: "IT", dialCode: "+39" },
  // { name: msg({ id: "Country_name_jp", message: "Japan" }), iso2: "JP", dialCode: "+81" },
  // { name: msg({ id: "Country_name_my", message: "Malaysia" }), iso2: "MY", dialCode: "+60" },
  // { name: msg({ id: "Country_name_mx", message: "Mexico" }), iso2: "MX", dialCode: "+52" },
  // { name: msg({ id: "Country_name_nl", message: "Netherlands" }), iso2: "NL", dialCode: "+31" },
  // { name: msg({ id: "Country_name_nz", message: "New Zealand" }), iso2: "NZ", dialCode: "+64" },
  // { name: msg({ id: "Country_name_no", message: "Norway" }), iso2: "NO", dialCode: "+47" },
  // { name: msg({ id: "Country_name_ph", message: "Philippines" }), iso2: "PH", dialCode: "+63" },
  // { name: msg({ id: "Country_name_pl", message: "Poland" }), iso2: "PL", dialCode: "+48" },
  // { name: msg({ id: "Country_name_pt", message: "Portugal" }), iso2: "PT", dialCode: "+351" },
  // { name: msg({ id: "Country_name_ro", message: "Romania" }), iso2: "RO", dialCode: "+40" },
  // { name: msg({ id: "Country_name_ru", message: "Russia" }), iso2: "RU", dialCode: "+7" },
  // { name: msg({ id: "Country_name_sg", message: "Singapore" }), iso2: "SG", dialCode: "+65" },
  // { name: msg({ id: "Country_name_kr", message: "South Korea" }), iso2: "KR", dialCode: "+82" },
  // { name: msg({ id: "Country_name_es", message: "Spain" }), iso2: "ES", dialCode: "+34" },
  // { name: msg({ id: "Country_name_se", message: "Sweden" }), iso2: "SE", dialCode: "+46" },
  // { name: msg({ id: "Country_name_ch", message: "Switzerland" }), iso2: "CH", dialCode: "+41" },
  // { name: msg({ id: "Country_name_tw", message: "Taiwan" }), iso2: "TW", dialCode: "+886" },
  // { name: msg({ id: "Country_name_th", message: "Thailand" }), iso2: "TH", dialCode: "+66" },
  // { name: msg({ id: "Country_name_tr", message: "Turkey" }), iso2: "TR", dialCode: "+90" },
  // { name: msg({ id: "Country_name_ua", message: "Ukraine" }), iso2: "UA", dialCode: "+380" },
  // { name: msg({ id: "Country_name_ae", message: "United Arab Emirates" }), iso2: "AE", dialCode: "+971" },
  // { name: msg({ id: "Country_name_gb", message: "United Kingdom" }), iso2: "GB", dialCode: "+44" },
  // { name: msg({ id: "Country_name_us", message: "United States" }), iso2: "US", dialCode: "+1" },
  // { name: msg({ id: "Country_name_vn", message: "Vietnam" }), iso2: "VN", dialCode: "+84" },
];
